import { render, staticRenderFns } from "./RegisterRiderVehicle.vue?vue&type=template&id=3f930efe&scoped=true"
import script from "./RegisterRiderVehicle.vue?vue&type=script&lang=js"
export * from "./RegisterRiderVehicle.vue?vue&type=script&lang=js"
import style0 from "./RegisterRiderVehicle.vue?vue&type=style&index=0&id=3f930efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f930efe",
  null
  
)

export default component.exports